export default {
  'calander.guide': 'دليل التقويم',
  'calander.redtheme': 'اللون الأحمر',
  'calander.graytheme': 'اللون الرمادي',
  'calander.greentheme': 'اللون الأخضر',
  'calander.bluetheme': 'اللون الأزرق',
  'calander.guidetitle': 'ألوان المناسبات تحت التقويم هي كما يلي.',
  'calander.redthemeguide':
    'يشير هذا اللون إلى العطلات الرسمية حسب البلد المحدد.',
  'calander.graythemeguide':
    'يشير هذا اللون إلى المناسبات الدينية للبلد المحدد.',
  'calander.greenthemeguide':
    'يشير هذا اللون إلى المناسبات الأصلية للبلد المحدد.',
  'calander.bluethemeguide':
    'يشير هذا اللون إلى المناسبة المحلية التقليدية للبلد المحدد.',
  'calander.selectCountry': 'اسم البلد لعرض الأحداث',
  'calander.changeDate': 'تغيير التاريخ',
  'calander.changeType': 'تغيير النوع',
  'calander.shamsi': 'شمسي',
  'calander.miladi': 'ميلادي',
  'calander.hijri': 'هجري',
  'otheroption.otheroptions': 'خيارات أخرى',
  'calendar.calculateDate': 'حساب التواريخ',
  'otheroption.departuredate': 'تاريخ المغادرة',
  'otheroption.returndate': 'تاريخ العودة',
  'otheroption.dayscount': 'حساب الأيام',
  'otheroption.calculate': 'حساب',
  'otheroption.timeinterval': 'الفاصل الزمني (العمر)',
  'otheroption.alertinsertresult.ar': 'التاريخ المدخل غير صالح.',
  'otheroption.untiltodayfuture': 'الوقت المتبقي من اليوم.',
  'otheroption.untiltodaypast': 'الوقت الذي مضى حتى اليوم.',
  'otheroption.otheroptionsguide1':
    'من خلال اختيار دولة في الجزء العلوي من التقويم، يتم تعيين الأحداث الخاصة بتلك الدولة على التقويم.',
  'otheroption.otheroptionsguide2':
    'عند وضع المؤشر على اليوم، إذا كان هناك حدث، سيتم عرضه في الجزء السفلي من التقويم.',
  'otheroption.otheroptionsguide3':
    'بالنقر على تاريخين، سيتم عرض الفاصل الزمني بينهما.',
  'otheroption.otheroptionsguide4':
    'جميع أحداث التقويم، يتم تقديمها في قائمة في قسم أحداث التقويم.',
};
